export class StrategyResolver {
  static extract (url:string): string {
    // eslint-disable-next-line
    let result = url.match(/[^\/\s]+/);

    return result ? result[0] : '';
  }
}
